import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { completeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      const res = await completeGoogleSession(sessionId);
      // clear hash
      window.history.replaceState(null, "", window.location.pathname);
      if (res.ok) {
        toast.success("Signed in.");
        navigate("/account");
      } else {
        setError(res.error);
      }
    })();
  }, [completeGoogleSession, navigate]);

  return (
    <div
      className="bg-black min-h-screen flex items-center justify-center text-white wc-label text-sm tracking-widest"
      data-testid="auth-callback"
    >
      {error ? `Error: ${error}` : "AUTHENTICATING..."}
    </div>
  );
}
